import { Temporal } from 'temporal-polyfill';
import { z } from 'zod';
import type { LocaleType } from '@/models/common/locale.ts';

export const DayOfWeekBrand = z.string().brand<'DayOfWeek'>();
export type DayOfWeek = z.infer<typeof DayOfWeekBrand>;

export class CalendarModel {
  private readonly locale: LocaleType;

  constructor(locale: LocaleType = 'en-US') {
    this.locale = locale;
  }

  daysOfWeek() {
    const df = new Intl.DateTimeFormat(this.locale, { weekday: 'short' });

    return Array.from({ length: 7 }, (_, i) => {
      // 16 is a Sunday, so we add the offset
      const dayIndex = 16 + i;
      return df.format(new Date(2021, 4, dayIndex));
    });
  }

  getMonthNames() {
    const formatter = new Intl.DateTimeFormat(this.locale, { month: 'long' });
    return Array.from({ length: 12 }, (_, i) => {
      return formatter.format(new Date(2023, i, 1));
    });
  }

  getTimeSlots() {
    return Array.from({ length: 10 }, (_, i) => {
      return Temporal.PlainTime.from({ hour: 8 + i, minute: 0 });
    });
  }

  getCalendarWeeks(yearMonth: Temporal.PlainYearMonth) {
    const firstDayOfMonth = yearMonth.toPlainDate({ day: 1 });
    const firstDayIndex = firstDayOfMonth.dayOfWeek % 7;

    const startDate = firstDayOfMonth.subtract({ days: firstDayIndex });

    const weeks: Temporal.PlainDate[][] = [];
    for (let w = 0; w < 6; w++) {
      const week: Temporal.PlainDate[] = [];
      for (let d = 0; d < 7; d++) {
        week.push(startDate.add({ days: w * 7 + d }));
      }
      weeks.push(week);
    }

    return weeks;
  }
}
